// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"3cc171e0","441":"9a77601a","639":"0d03ff9e"}[chunkId] + ".chunk.js";
};